// extracted by mini-css-extract-plugin
export default {"gameWrapper":"GameWrapper_gameWrapper__A7RxQ","gameWrapper__container":"GameWrapper_gameWrapper__container__5dmV2","gameWrapper__main":"GameWrapper_gameWrapper__main__l1wAJ"};